import React from 'react';
import { ClipLoader } from 'react-spinners'

const LableWithLoader = (props) => {

  return (
    <span className='flex-l button-label'>
      {props.text}
    <span className='button-loader'>
      <ClipLoader
        color={'white'}
        loading={props.loader}
        size={25}
      />
    </span>
  </span>
  )
}

export default LableWithLoader;




// WEBPACK FOOTER //
// ./src/components/LabelWithLoader.js